// Vendors
import styled, { css } from 'styled-components';
import { COBRANDED_LIGHT_REGULAR_BASE_STYLES } from '@openbank/ziniaweb-ui-components';
// Utilities
import { convertPxsToRems } from '@openbank/cf-ui-framework';

const LayoutOperationalComponentStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing_300};
  text-align: left;
  width: 100%;

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    align-items: stretch;
  }
`;
LayoutOperationalComponentStyled.displayName = 'LayoutOperationalComponentStyled';

const LayoutOperationalMaxWidthComponentStyled = styled.div<{ paddingContent?: boolean }>`
  max-width: ${convertPxsToRems({ pixels: 682, base: 16 })};
  width: 100%;
  margin: 0 auto;

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    padding: 0 ${({ paddingContent, theme }) => (paddingContent ? '0' : theme.spacing_300)};
    max-width: 100%;
  }
`;
LayoutOperationalMaxWidthComponentStyled.displayName = 'LayoutOperationalMaxWidthComponentStyled';

const LayoutOperationalBottomSideComponentStyled = styled(LayoutOperationalComponentStyled)<{
  hasTitle?: string;
}>`
  ${({ hasTitle }) =>
    hasTitle
      ? css`
          padding: ${({ theme }) => theme.spacing_300} 0 ${({ theme }) => theme.spacing_150};
        `
      : css`
          padding: 0;
        `}

  ${LayoutOperationalMaxWidthComponentStyled}
`;
LayoutOperationalBottomSideComponentStyled.displayName =
  'LayoutOperationalBottomSideComponentStyled';

export {
  LayoutOperationalComponentStyled,
  LayoutOperationalMaxWidthComponentStyled,
  LayoutOperationalBottomSideComponentStyled,
};
